var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attachments--list"},_vm._l((_vm.attachments),function(attachment){return _c('item',{key:attachment.id,attrs:{"model":attachment,"all-categories":_vm.categories},on:{"remove":_vm.removeItem,"updateCategories":_vm.updateItemCategories}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }